import type { FaireProductEntity } from "../../entity_types/product";

export const p_r3zthj9g28: FaireProductEntity = {
  token: "p_r3zthj9g28",
  type: "product",
  name: "Hygge - Vanilla, Tobacco & Cedar Coconut Soy 8oz Candle",
  brandToken: "b_f2njjv4jzw",
  brandName: "Milk Jar Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/7aea1b4577a517926a432d1d0a401537ec7f0b1a5b728a0740687c8813ee8344.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7681e690ecc5dd03afee1bb82f3500e7539aa2d8a063bcce937bcf94dbe0ae74.jpeg",
    "https://cdn.faire.com/fastly/fdef6a131890440a00052014585243babad3d511c57822e2a8675df786a9f65b.jpeg",
    "https://cdn.faire.com/fastly/1f2c77bb0a579fad91d66a50f9b543e0bbe007bd16cc0d48f524f5710b5ec502.jpeg",
    "https://cdn.faire.com/fastly/513f58fb1c4855505f6ef118886f619119ad8874e632ffbb9a56ed55437ff5be.jpeg",
    "https://cdn.faire.com/fastly/934969ab88d71ce2d878b6234682005c00b69c867db30ee3db22da87d6554fe9.jpeg",
    "https://cdn.faire.com/fastly/9ca0c739f01e4aeb775cbd597a9caffdd4e4d167c27dd6e1503a7304a84e126a.jpeg",
    "https://cdn.faire.com/fastly/9a096c90815b933ecb9d2d8d08f7a026ade34d6a3971586eca08bef39361bb70.jpeg",
    "https://cdn.faire.com/fastly/c0f19070de7c41ded777dd53e58868c876ec4053844ccdffc61f2cbb6cbba4f8.jpeg",
    "https://cdn.faire.com/fastly/68fb0a99cade72c339f923eb65875820dd40e10a6af362c4f7777c8910716db8.jpeg",
    "https://cdn.faire.com/fastly/f71fac208954ac9b017dce13de860fe318923e6be0ac0bb6e273bb84d18c5348.jpeg",
    "https://cdn.faire.com/fastly/3595e8f75fa0c298175644ca370277c28897696cc89c3cef2e2668f7716f2353.jpeg",
  ],
  priceDollars: 14.32,
  description:
    "Vanilla, Tobacco, Cedar & Sea Salt · 8 oz Original Candle\n\nOh wow. Are you ready for this? Get cozy, get lazy and get those comfy clothes on because home is where the hygge (hoo-gah) is and the pants are not! Curl up in warm vanilla, anise and relaxing cedar goodness, and become one with the duvet.\n\n• $1 from every candle sold supports the creation of inclusive and inviting spaces around the world\n• Crackling wooden wick\n• Plant based coconut soy wax\n• Scented with high-quality fragrance oils, free from dibutyl phthalates (DBP) and di(2-ethylhexyl) phthalates (DEHP)\n• Vegan and cruelty-free\n• 40-45 hour burn time with proper wick trimming\n• Hand-poured in sunny Calgary",
  tags: [],
  msrpDollars: 30.38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:08.817Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
